export { QrCodeGuard } from './guards';
